
export const TickIcon = () => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Círculo */}
            <circle
            cx="25"
            cy="25"
            r="23"
            stroke="black"
            strokeWidth="2"
            fill="none"
            />
            {/* Tick */}
            <path
            d="M15 25 L22 32 L35 18"
            stroke="green"
            strokeWidth="4"
            fill="none"
            />
        </svg>
  );
}

